<div class="sayso-preview-top-bar">
  {{ "ONSIP_I18N.WELL_GET_YOU_TO_THE_RIGHT_PLACE_RIGHT_PERSON_RIGHT_NOW" | translate }}
</div>
<div>
  <mat-divider onsip-dotted-divider></mat-divider>
</div>
<div class="sayso-preview-main">
  @for (topic of topics; track topic; let isLast = $last) {
  <div class="sayso-department-call-options">
    <div class="primary-text">
      {{ topic.targetDisplay }}
    </div>
    @if (topic.repName) {
    <div class="secondary-text">
      {{ topic.repName | firstname }} {{ "ONSIP_I18N.CAN_TALK_IMMEDIATELY" | translate }}
    </div>
    } @if (!topic.repName) {
    <div class="secondary-text">
      {{ "ONSIP_I18N.ALL_REPS_ARE_CURRENTLY_BUSY" | translate }}
    </div>
    } @if (topic.repName) {
    <div class="sayso-preview-button-container">
      <onsip-avatar [avatarUrl]="topic.repAvatarUrl" [name]="topic.repName"></onsip-avatar>
      <button
        class="sayso-preview-main-button"
        [style.background-color]="accentColor"
        [style.color]="accentColor | textColorForCustomBackground"
      >
        <mat-icon>call</mat-icon>
        {{ "ONSIP_I18N.CALL_NOW" | translate }}
      </button>
      @if (topic.video) {
      <button
        class="sayso-preview-video-button"
        [style.background-color]="accentColor"
        [style.color]="accentColor | textColorForCustomBackground"
      >
        <mat-icon>videocam</mat-icon>
      </button>
      }
    </div>
    } @if (!topic.repName) {
    <div class="sayso-preview-button-container">
      <button
        class="sayso-preview-main-button"
        [style.background-color]="accentColor"
        [style.color]="accentColor | textColorForCustomBackground"
      >
        {{ "ONSIP_I18N.NOTIFY_ME" | translate }}
      </button>
    </div>
    }
  </div>
  <div>
    @if (!isLast) {
    <mat-divider onsip-dotted-divider></mat-divider>
    }
  </div>
  }
</div>
